<template>
	<div class="detail-page">
		<div class="detail-page__header">
			<h2 class="detail-page__header-title">
				{{ detail.title }}
			</h2>
			<p class="detail-page__header-time">
				发布时间：{{ detail.publishtime | formatDate }}
			</p>
		</div>
		<div class="detail-page__content" v-html="detail.content"></div>
		<div class="detail-page__footer">
			<div>
				<span>上一篇：</span
				><router-link
					:to="{ path: turnPageUrl + detail.prevId }"
					v-if="detail.prevId"
					>{{ detail.prevTitle}}</router-link
				>
				{{ detail.prevId ? '' : '无' }}
			</div>
			<div>
				<span>下一篇：</span
				><router-link
					:to="{ path: turnPageUrl + detail.nextId }"
					v-if="detail.nextId"
					>{{ detail.nextTitle }}</router-link
				>
				{{ detail.nextId ? '' : '无' }}
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	props: {},
	data() {
		return {}
	},
	computed: {
		...mapState('YQDT', ['detail']),
		// 翻页
		turnPageUrl() {
			const orgPath = this.$route.fullPath
			const len = orgPath.lastIndexOf('/') + 1
			return orgPath.substr(0, len)
		},
	},
	mounted() {
		const pathMatch = this.$route.params.pathMatch || ''
		const mapPath = ['news', 'notice', 'technologyPolicy']
		const params = {
			id: this.$route.params.id,
			parkType: mapPath.indexOf(pathMatch) + 1,
		}
		this.fetchDetail(params)
	},
	watch: {},
	methods: {
		...mapActions('YQDT', ['fetchDetail'])
	},
	components: {},
}
</script>

<style lang="scss"></style>
